
    var runtime = require('vue-svg-component-runtime')
    module.exports = {
      __esModule: true,
      default: runtime.svgComponent({
  "tag": "svg",
  "attrsMap": {
    "version": "1.1",
    "id": "图层_1",
    "xmlns": "http://www.w3.org/2000/svg",
    "xmlns:xlink": "http://www.w3.org/1999/xlink",
    "x": "0px",
    "y": "0px",
    "width": "17px",
    "height": "17px",
    "viewBox": "0 0 17 17",
    "enable-background": "new 0 0 17 17",
    "xml:space": "preserve"
  },
  "children": [
    {
      "tag": "g",
      "attrsMap": {
        "id": "营销中心",
        "transform": "translate(-1042 -664)"
      },
      "children": [
        {
          "tag": "g",
          "attrsMap": {
            "id": "营销中心-2",
            "transform": "translate(976.16 598.126)"
          },
          "children": [
            {
              "tag": "path",
              "attrsMap": {
                "id": "路径_1",
                "fill": "#FFFFFF",
                "d": "M68.973,80.079h0.875c0.725,0,1.313-0.588,1.313-1.313v-3.5\n\t\t\tc-0.001-0.724-0.588-1.311-1.312-1.312h-0.875c-0.725,0-1.312,0.588-1.313,1.313v3.5C67.662,79.492,68.249,80.079,68.973,80.079z\n\t\t\t M68.535,75.267c0-0.241,0.197-0.437,0.438-0.437h0.875c0.242,0,0.438,0.196,0.438,0.438v3.5c0,0.24-0.195,0.438-0.437,0.438\n\t\t\th-0.875c-0.241,0-0.438-0.195-0.438-0.438L68.535,75.267z"
              }
            },
            {
              "tag": "path",
              "attrsMap": {
                "id": "路径_2",
                "fill": "#FFFFFF",
                "d": "M73.622,80.079h0.875c0.725,0,1.312-0.588,1.313-1.313v-6.125\n\t\t\tc-0.001-0.724-0.587-1.311-1.312-1.312h-0.875c-0.725,0.001-1.312,0.588-1.313,1.313v6.125\n\t\t\tC72.312,79.491,72.899,80.078,73.622,80.079L73.622,80.079z M73.185,72.642c0.001-0.242,0.197-0.437,0.438-0.437h0.875\n\t\t\tc0.242,0,0.438,0.196,0.438,0.438v6.125c0,0.24-0.195,0.438-0.437,0.438h-0.875c-0.241,0-0.437-0.196-0.438-0.438L73.185,72.642z"
              }
            },
            {
              "tag": "path",
              "attrsMap": {
                "id": "路径_3",
                "fill": "#FFFFFF",
                "d": "M78.319,80.079h0.875c0.752-0.029,1.34-0.662,1.313-1.415V68.289\n\t\t\tc0.026-0.752-0.561-1.385-1.313-1.415h-0.875c-0.752,0.03-1.338,0.663-1.312,1.415v10.376\n\t\t\tC76.981,79.417,77.567,80.049,78.319,80.079L78.319,80.079z M77.881,68.289c-0.01-0.251,0.188-0.462,0.438-0.472h0.875\n\t\t\tc0.252,0.01,0.447,0.221,0.438,0.472v10.376c0.009,0.251-0.187,0.462-0.437,0.473H78.32c-0.252-0.011-0.447-0.222-0.438-0.473\n\t\t\tL77.881,68.289z"
              }
            },
            {
              "tag": "path",
              "attrsMap": {
                "id": "路径_4",
                "fill": "#FFFFFF",
                "d": "M81.349,80.954H67.331c-0.169-0.01-0.331,0.07-0.424,0.212c-0.088,0.137-0.088,0.313,0,0.45\n\t\t\tc0.094,0.141,0.255,0.221,0.424,0.212h14.018c0.169,0.009,0.331-0.071,0.425-0.212c0.088-0.137,0.088-0.313,0-0.45\n\t\t\tC81.68,81.024,81.518,80.944,81.349,80.954z"
              }
            }
          ]
        }
      ]
    }
  ]
})
    }
  